import chevron from './chevron.svg';
import eyeClose from './eye-close.svg';
import eyeOpen from './eye-open.svg';
import logout from './log-out.svg';
import pdf from './pdf.svg';
import signUp from './sign-up.svg';
import closeX from './x.svg';

export const ICONS_24PX_MAP = {
    chevron,
    signUp,
    closeX,
    logout,
    eyeClose,
    eyeOpen,
    pdf,
};
